import React from 'react';
import PropTypes from 'prop-types';
import REDUCER_KEY from 'reducers/reducer.keys';
import { Inner } from 'components/Page';
import config from './config';

const ValidationTasks = ({ objectId, permissions }) => (
  <Inner
    canAdmin={permissions.CanAdminRosters()
      .hasPermissions()}
    reducer={{
      parent: REDUCER_KEY.validation,
      item: REDUCER_KEY.validationTask,
      list: REDUCER_KEY.validationTasks
    }}
    config={{
      ...config,
      list: {
        ...config.list,
        filters: {
          validation__id: [objectId]
        }
      },
      detail: {
        ...config.detail,
        parent: {
          validation__id: [objectId]
        }
      }
    }}
    defaultSize="250px"
    defaultKey="1"
    listOnTop={false}
  />
);

ValidationTasks.propTypes = {
  objectId: PropTypes.number,
  permissions: PropTypes.object.isRequired
};

ValidationTasks.defaultProps = {
  objectId: null
};

export default ValidationTasks;
